import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Notepad from './components/Notepad';
import Blog from './components/Blog';
import Terms from './components/Terms';
import Privacy from './components/Privacy';
import Header from './components/Header';
import Footer from './components/Footer';
import SeoUpdater from './components/SeoUpdater';
import './styles/index.css';
import './styles/features.css';
import './styles/blog.css';

/**
 * 应用主组件，用于组织页面结构和加载用户首选语言
 */
function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    // 从本地存储中加载首选语言
    const savedLanguage = localStorage.getItem('preferredLanguage');
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }

    // 设置已访问标记
    localStorage.setItem('hasVisited', 'true');
  }, [i18n]);

  return (
    <Router>
      <div className="app-container">
        <SeoUpdater />
        <Header />

        <main className="editor-container">
          <Routes>
            <Route path="/" element={<Notepad />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;